import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../../../components/Button/button";
import { LoadingBackDrop } from "../../../../../components/loader";
import { theme } from "../../../../../helpers/theme";
import { generateOffers } from "../../../../../services/offers/generate-offers";
import { ordersAdd } from "../../../../../services/orders/orders-add";
import {
  DistanceUnit,
  OrderAddRequestBody,
  WeightUnit,
} from "../../../../../services/orders/orders-add/types";
import SessionService from "../../../../../services/session-service";
import { url } from "../../../../../utils/url";
import {
  setAdditionalStorageMethodEnum,
  setGoodsTypeEnum,
  setPackageTypeEnum,
  setPalceEnum,
  setStorageMethodEnum,
  setTemperatureConditionEnum,
  setTimezoneDate,
  setTimezoneDateEnd,
} from "./helpers";

export const SubmitAnInquiryButton = () => {
  const navigate = useNavigate();
  const user = SessionService.getUser();
  const isLogged = user && user.token_dostepu !== null ? true : false;
  const ordersAddMutation = useMutation(ordersAdd, {
    onSuccess: (res) => {
      SessionService.clearOrder();
      const order_identification = {
        id_zamowienie: res.data.payload.id_zamowienie,
        numer_zamowienia: res.data.payload.numer_zamowienia,
      };
      SessionService.setOrderIdentification(order_identification);
      navigate(url.offerCreate);

      //generateOffersMutation.mutate(body)
    },
  });

  // const generateOffersMutation = useMutation(generateOffers, {
  //   onSuccess: (data) => {
  //     //navigate(url.offerCreate);
  //   },
  // });

  const order = SessionService.getOrder();
  const body: OrderAddRequestBody = {
    opis_uslugi: order.opis_uslugi,
    termin_rozpoczecia: setTimezoneDate(order.termin_rozpoczecia),
    termin_zakonczenia: setTimezoneDateEnd(order.termin_zakonczenia),
    kraj: order.kraj,
    wojewodztwo: order.wojewodztwo,
    kod_pocztowy: order.kod_pocztowy,
    miasto: order.miasto,
    szerokosc_geograficzna: order.szerokosc_geograficzna,
    dlugosc_geograficzna: order.dlugosc_geograficzna,
    miejsce: setPalceEnum(order.miejsce),
    skladowanie_plaskie: order.rodzaj_skladowania === "Płaskie" ? true : false,
    wysokie_skladowanie: order.rodzaj_skladowania === "Wysokie" ? true : false,
    polki: order.rodzaj_skladowania === "Półki" ? true : false,
    warunek_temperaturowy: setTemperatureConditionEnum(
      order.warunek_temperaturowy
    ),
    rodzaj_towaru: setGoodsTypeEnum(order.rodzaj_towaru),
    opis_towaru: order.opis_towaru,
    specjalny_sprzet: order.specjalny_sprzet,
    dodatkowe_uwagi: order.dodatkowe_uwagi,
    uslugi_zamowione: {
      cel_zamowienia: setStorageMethodEnum(
        order.uslugi_zamowione.cel_zamowienia
      ),
      uslugi_dodatkowe: setAdditionalStorageMethodEnum(
        order.uslugi_zamowione.uslugi_dodatkowe
      ),
      ilosc_dodatkowych: order.uslugi_zamowione.ilosc_dodatkowych,
    },
    przedmioty_skladowania: [
      {
        rodzaj_opakowania: setPackageTypeEnum(order.rodzaj_opakowania),
        dodatkowe_info: null,
        ilosc: order.ilosc,
        waga: order.waga / order.ilosc,
        dlugosc: order.dlugosc,
        szerokosc: order.szerokosc,
        wysokosc: order.wysokosc,
        rozmiar: order.rozmiar,
        jednostka_wagi: WeightUnit.Kg,
        jednostka_dlugosci: DistanceUnit.Mm,
      },
    ],

    klient: isLogged
      ? null
      : {
          nazwa: order.klient.nazwa,
          nip: order.klient.nip,
          telefon: order.klient.telefon,
          email: order.klient.email,
          info_dodatkowe: "",
          adres_klienta: null,
        },
    email_operatora: null,
  };
  const handleSubmit = () => {

    ordersAddMutation.mutate(body);
  };
  if (ordersAddMutation.isLoading) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <StyledButton
        sx={{ width: "100%", maxWidth: "240px" }}
        onClick={handleSubmit}
      >
        Złóż zapytanie ofertowe
      </StyledButton>
    </>
  );
};

const Title = styled.div`
  margin-top: 48px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.big};
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.black_primaryText};
  padding-bottom: 12px;
`;
const Description = styled.div`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.gray01_secondaryText};
`;
